// extracted by mini-css-extract-plugin
export default {"fallback":"Fallback_fallback__f0mMB","content":"Fallback_content__xBG3h"};